<template>
  <div class="stand">
    <Header />
    <div class="container wide mt-4">
      <div class="box">
        <div class="row">
          <div class="col-md-12">
            <img
              class="img-fluid"
              src="@/assets/plavix_banner.jpg"
              alt="Stand Banner"
            />
          </div>
        </div>
        <div class="row p-4">
          <div class="col-md-7">
            <div class="embed-responsive embed-responsive-16by9">
              <iframe
                src="https://player.vimeo.com/video/534770086?loop=1&autoplay=1"
                width="640"
                height="480"
                frameborder="0"
                allow="autoplay; fullscreen"
                allowfullscreen
              ></iframe>
            </div>

            <!--
            <p class="mt-4">
              Lorem ipsum dolor sit amet consectetur adipisicing elit.<br />
              Pariatur vero sequi esse ad provident deleniti in eum quis,
              aperiam quod quia.
            </p>
            -->
          </div>
          <div class="col-md-5 stand-buttons">
            <div>
              <a href="https://sanofi.zoom.com/j/8194821983" target="_blank">
                <span>Canlı Görüşme</span>
              </a>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Header from '@/components/Header.vue';

export default {
  data() {
    return {
      booth: null,
      isReady: false,
    };
  },
  components: {
    Header,
  },
  computed: {},
  methods: {},
  created() {},
};
</script>

<style lang="scss">
.stand {
  padding-top: 0px;
  display: flex;
  flex-direction: column;

  .box {
    padding-top: 15px;
  }

  .container {
    border-radius: 8px;
    background-color: #fff;
    height: fit-content;
  }
}
/*Stand Buttons*/
.stand-buttons {
  div {
    background: #f5f5f5;
    padding: 2rem;
    height: 100%;

    a {
      display: flex;
      align-items: center;
      color: black;
      font-weight: 600;
      text-decoration: none;
      background-color: #fff;
      border-radius: 3px;
      box-shadow: 0px 2px 4px rgba(0, 0, 0, 0.09);
      padding: 1.125rem;
      margin-bottom: 1rem;
      border: 1px solid transparent;
      transition: border-color 0.4s ease;
      line-height: 1.2;

      span {
        small {
          display: block;
          font-size: 0.875rem;
          color: rgba(0, 0, 0, 0.4);
        }
      }

      img {
        width: 2rem;
        margin-right: 0.5rem;
      }

      &:hover {
        span {
          color: #000;
        }

        border-color: #ccc;
      }
    }
  }
}

/*Stand Buttons Responsive*/
@media only screen and (max-width: 480px) {
  .stand-buttons div {
    padding: 1rem;
  }
}

/*End Stand Buttons Responsive*/
</style>
